import React, { useState, useEffect } from "react";

const TestAPI = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const testAPI = async () => {
      try {
        console.log("Testing API...");
        const response = await fetch("https://iudi-api.thinkdiff.us/api/listings?page=1");
        console.log("Response status:", response.status);
        console.log("Response headers:", response.headers);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        console.log("API Response:", result);
        setData(result);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    testAPI();
  }, []);

  if (loading) return <div>Đang test API...</div>;
  if (error) return <div>Lỗi: {error}</div>;

  return (
    <div style={{ padding: "20px", background: "#1e293b", color: "#e5e7eb", minHeight: "100vh" }}>
      <h1>Test API Results</h1>
      <pre style={{ background: "#334155", padding: "16px", borderRadius: "8px", overflow: "auto" }}>
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default TestAPI;
